import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import EventReviews from "./pages/EventReviews";
import NotFound from "./pages/NotFound";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                        path="/reviews/:eventId"
                        element={<EventReviews />}
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <FloatingCTA />
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
